import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UiModalComponent } from '@tekman/shared/component/shared';
import { ModalData, ModalOptions } from '@tekman/shared/models';
import { Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root',
})
export class ModalFactoryService<T = undefined> {
  public isClicked: Subject<void> = new Subject<void>();
  public overlayClicked$ = this.isClicked.asObservable();
  private dialogRef: MatDialogRef<UiModalComponent<T>, any>[] = [];

  constructor(private readonly dialog: MatDialog) {}

  open(dialogData: ModalData<T>, options: ModalOptions = { width: 500, disableClose: true }): ModalService<T> {
    this.dialogRef.push(
      this.dialog.open<UiModalComponent<T>, ModalData<T>>(UiModalComponent, {
        ...this.fetchOptions(options),
        data: dialogData,
        autoFocus: false,
      })
    );
    this.peek().afterClosed().pipe(first());
    this.peek()
      .backdropClick()
      .subscribe(() => {
        this.isClicked.next();
      });
    return new ModalService(this.peek());
  }

  private fetchOptions({
    width,
    disableClose,
    panelClass,
    id,
  }: ModalOptions): Pick<MatDialogConfig<ModalData<T>>, 'width' | 'disableClose' | 'panelClass' | 'id'> {
    return { width: `${width}px`, disableClose, panelClass, id };
  }

  get getDialogRef() {
    return this.peek();
  }

  close() {
    if (this.dialogRef.length > 0) {
      this.dialogRef.pop().close();
    }
  }

  private peek() {
    return this.dialogRef[this.dialogRef.length - 1];
  }
}
